"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExperimentValue = exports.useFeatureGate = void 0;
const react_1 = require("react");
const feature_gate_js_client_1 = __importDefault(require("@atlaskit/feature-gate-js-client"));
const useFeatureGate = (gateName, options = {}) => {
    const [gate, setGate] = (0, react_1.useState)(() => feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, react_1.useEffect)(() => {
        const onGateChange = (newValue) => setGate(newValue);
        return feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [gateName, options]);
    return gate;
};
exports.useFeatureGate = useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const useExperimentValue = (experimentName, parameterName, defaultValue, options = {}) => {
    const [experimentValue, setExperimentValue] = (0, react_1.useState)(() => feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, react_1.useEffect)(() => {
        const onExperimentValueChange = (newValue) => setExperimentValue(newValue);
        return feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [experimentName, parameterName, defaultValue, options]);
    return experimentValue;
};
exports.useExperimentValue = useExperimentValue;
